// OpenApiKey, AzureApiKey

// --- Simple Base64 helpers ---
function b64encode(str) {
  return btoa(unescape(encodeURIComponent(str)));
}

function b64decode(str) {
  return decodeURIComponent(escape(atob(str)));
}

// --- Very simple XOR with password ---
function xorEncryptDecrypt(str, password) {
  return str
    .split("")
    .map((char, i) =>
      String.fromCharCode(char.charCodeAt(0) ^ password.charCodeAt(i % password.length))
    )
    .join("");
}

// --- Encrypt data ---
export function encryptData(data, password) {
  if (!password) {
    password = "tokenEncryptionKey1234567890";
  }
  const xored = xorEncryptDecrypt(data, password);
  return b64encode(xored);
}

// --- Decrypt back to data ---
export function decryptData(token, password) {
  const decoded = b64decode(token);
  return xorEncryptDecrypt(decoded, password);
}
